module.exports = __webpack_public_path__ + "0dcbc328f61e486f30312f68a980b9cd.svg";